var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[_vm._v(" "+_vm._s(_vm.orderStatus)+" "),_c('br'),_vm._v(" ("+_vm._s(_vm.deliveryStatus)+") ")])
}
var staticRenderFns = []

export { render, staticRenderFns }